import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import store from '../store/store.js';

Vue.use(Vuetify);

import {
  VUE_APP_BRAND_COLOR,
  VUE_APP_INFO_COLOR,
  VUE_APP_PRIMARYBTN_COLOR
} from '@/utilities/constants.js';

const lang = localStorage.getItem('langOption') || store.state.defaultLanguage;

export default new Vuetify({
  theme: {
    themes: {
      light: {
        accent: '#82B1FF',
        borderColor: '#EAEAEA',
        brand: VUE_APP_BRAND_COLOR,
        error: '#D31616',
        info: VUE_APP_INFO_COLOR,
        inputBg: '#F6F8FA',
        primary: '#34495E',
        primaryBtn: VUE_APP_PRIMARYBTN_COLOR,
        secondary: '#424242',
        success: '#4CAF50',
        warning: '#FFC107'
      }
    },

    options: {
      customProperties: true
    }
  },
  icons: {
    iconfont: 'mdiSvg'
  },
  lang: {
    current: lang
  }
});
